import { useRef, VFC } from 'react';
import styled from 'styled-components';

import Tooltip from 'dashboard/components/Tooltip';

const CellContainer = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 100%;
`;

interface CellProps {
  text: string;
}

const Cell: VFC<CellProps> = ({ text }) => {
  const el = useRef(null);
  const displayText = text || '-';
  // check if ellipsis is being applied
  const content =
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    el.current?.offsetWidth < el.current?.scrollWidth ? (
      <Tooltip placement='top' trigger='hover' tooltip={text} hideArrow={false}>
        {displayText}
      </Tooltip>
    ) : (
      displayText
    );
  return <CellContainer ref={el}>{content}</CellContainer>;
};

export default Cell;
